import React from 'react'
import {
  Container,
  Grid,
  Typography,
  Box,
  TextField,
  makeStyles,
  Divider,
  useMediaQuery,
} from '@material-ui/core';
import { red } from '@mui/material/colors';
import { withTheme } from 'styled-components';
import { useEffect, useState } from 'react';

const CalInfo = () => {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Adjust breakpoint as needed
    };

    handleResize(); // Check on initial render
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <Box maxWidth="xl" ml={isMobile ? 0 : 10} mr={isMobile ? 0 : 10} bgcolor={'#ffffff'}>
      <Typography variant="h2" style={{ flexShrink: 0, fontSize: '32px', fontFamily: 'Inter', fontWeight: 700, color: '#31B9B5', marginTop: '25px', marginBottom: '25px' }}>
        How we calculate
      </Typography>


      <div>
        <Typography variant="h6 " style={{ flexShrink: 0, fontSize: '16px', lineHeight: '36px', fontFamily: 'Inter', fontWeight: 500, textAlign: 'justify', marginBottom: '25px' }}>
          Our mortgage calculator simplifies the payment estimation process. We consider loan amount, interest rate, loan term, and taxes to provide an accurate monthly payment projection. Plan your homeownership journey with confidence, knowing your financial commitments in advance.
        </Typography>
        <Typography variant="h6" style={{ flexShrink: 0, fontSize: '16px', lineHeight: '36px', fontFamily: 'Inter', fontWeight: 500, textAlign: 'justify', marginBottom: '25px' }}><b>Loan principal</b></Typography>
        <Typography variant="h6" style={{ flexShrink: 0, fontSize: '16px', lineHeight: '36px', fontFamily: 'Inter', fontWeight: 500, textAlign: 'justify', marginBottom: '25px' }}>
          This is the loan amount applied for. For a loan against property, the maximum quantum can be up to 90% of a property's market price.
          For property loans, the maximum limit is usually 80% of the property value.
        </Typography>

        <Typography variant="h6" style={{ flexShrink: 0, fontSize: '16px', lineHeight: '36px', fontFamily: 'Inter', fontWeight: 500, textAlign: 'justify', marginBottom: '25px' }}><b>Repayment tenor</b></Typography>
        <Typography variant="h6" style={{ flexShrink: 0, fontSize: '16px', lineHeight: '36px', fontFamily: 'Inter', fontWeight: 500, textAlign: 'justify', marginBottom: '25px' }}>
          This is the repayment term within which the credit is to be settled. High-valued loans, such as loans against property,
          come with increased repayment flexibility. One can opt to repay the loan over a term extending up to 15 years*.
          This factor is crucial for a mortgage loan calculator to function.
        </Typography>

        <Typography variant="h6" style={{ flexShrink: 0, fontSize: '16px', lineHeight: '36px', fontFamily: 'Inter', fontWeight: 500, textAlign: 'justify', marginBottom: '25px' }}><b>Rate of interest</b></Typography>
        <Typography variant="h6" style={{ flexShrink: 0, fontSize: '16px', lineHeight: '36px', fontFamily: 'Inter', fontWeight: 500, textAlign: 'justify', marginBottom: '25px' }}>
          The last factor necessary for a mortgage loan calculator to work is the interest rate applicable against the said loan.
          This rate is quoted based on the borrower's eligibility and market conditions, among other factors.
        </Typography>

        <Typography variant="h6" style={{ flexShrink: 0, fontSize: '16px', lineHeight: '36px', fontFamily: 'Inter', fontWeight: 500, textAlign: 'justify', marginBottom: '100px' }}>
          Upon entering the information in these three fields, a Mortgage Loan EMI Calculator displays the monthly installment amount,
          the total interest outgo, and the total cost of the mortgage loan.
        </Typography>
      </div>

    </Box>
  )
}

export default CalInfo
